document.addEventListener('DOMContentLoaded', () => {
  function normalize(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss');
  }

  /*
   * Welche bestehende Einzel-Farbe soll bei einer
   * Farbkombination die Folgebilder liefern?
   */
  function getSourceColor(color) {
    const c = normalize(color);

    // Kombinationen mit Beige bekommen Beige-Bilder
    if (c.includes('beige')) return 'beige';

    // Blau/Grau und Blau/Weiß bekommen Dunkelblau-Bilder
    if (c.includes('blau')) return 'dunkelblau';

    // Grau/Weiß bekommt Grau-Bilder
    if (c.includes('grau')) return 'grau';

    if (c.includes('weiss')) return 'weiss';

    // Mix bekommt vorerst Beige-Bilder
    if (c.includes('mix')) return 'beige';

    return c;
  }

  function isSingleSet(value) {
    return normalize(value).includes('einzel');
  }

  function isStandard(value) {
    return normalize(value).includes('standard');
  }

  /*
   * Die data-media-id sitzt bei den großen Slides
   * auf einem Element innerhalb des Slide-Wrappers.
   */
  function getMediaElement(element) {
    if (
      element &&
      element.matches &&
      element.matches('[data-media-id]')
    ) {
      return element;
    }

    return element
      ? element.querySelector('[data-media-id]')
      : null;
  }

  function getMediaId(element) {
    const media = getMediaElement(element);

    return media
      ? String(media.dataset.mediaId || '')
      : null;
  }

  function getMediaPosition(element) {
    const media = getMediaElement(element);

    if (
      !media ||
      !media.dataset.mediaPosition
    ) {
      return 999999;
    }

    return Number(media.dataset.mediaPosition);
  }

  /*
   * Shared-Gallery nur für Produkte mit
   * dem Tag "shared-color-gallery".
   */
  function applySharedGallery(section, variantId) {
    const configElement = section.querySelector(
      '[data-shared-color-gallery-config]'
    );

    if (!configElement) {
      return false;
    }

    let config;

    try {
      config = JSON.parse(configElement.textContent);
    } catch (error) {
      console.error(
        'Shared Gallery: Konfiguration konnte nicht gelesen werden.',
        error
      );

      return false;
    }

    const selectedVariant =
      config.variants[String(variantId)];

    if (!selectedVariant) {
      console.warn(
        'Shared Gallery: Variante nicht in Config gefunden:',
        variantId
      );

      return false;
    }

    const variants =
      Object.entries(config.variants);

    const sourceColor =
      getSourceColor(selectedVariant.color);

    /*
     * Quellvariante finden:
     *
     * Einzelprodukt
     * + passende Grundfarbe
     * + Standard
     */
    let sourceEntry = variants.find(
      ([id, variant]) => {
        return (
          isSingleSet(variant.set) &&
          isStandard(variant.packaging) &&
          normalize(variant.color) === sourceColor
        );
      }
    );

    /*
     * Fallback:
     * falls bei der Grundfarbe keine Standard-Variante
     * gefunden werden sollte.
     */
    if (!sourceEntry) {
      sourceEntry = variants.find(
        ([id, variant]) => {
          return (
            isSingleSet(variant.set) &&
            normalize(variant.color) === sourceColor
          );
        }
      );
    }

    if (!sourceEntry) {
      console.warn(
        'Shared Gallery: Keine Quellvariante gefunden.',
        {
          selectedColor: selectedVariant.color,
          sourceColor: sourceColor
        }
      );

      return false;
    }

    const sourceVariant = sourceEntry[1];

    if (!sourceVariant.featuredMediaId) {
      console.warn(
        'Shared Gallery: Quellvariante hat kein Hauptbild.',
        sourceEntry
      );

      return false;
    }

    const slides = Array.from(
      section.querySelectorAll(
        '.product-gallery__slide'
      )
    );

    /*
     * Hauptbild der bestehenden Einzelprodukt-Galerie finden.
     */
    const sourceMainId =
      String(sourceVariant.featuredMediaId);

    const sourceMainSlide = slides.find(
      slide =>
        getMediaId(slide) === sourceMainId
    );

    if (!sourceMainSlide) {
      console.warn(
        'Shared Gallery: Quell-Hauptbild nicht gefunden:',
        sourceMainId
      );

      return false;
    }

    /*
     * WICHTIG:
     *
     * Das bestehende Theme hat bereits alle Folgebilder
     * mit einer data-variant-id gruppiert.
     *
     * Deshalb übernehmen wir exakt die Galerie-Gruppe,
     * die Shopify/Theme bereits dem Einzelprodukt
     * zugeordnet hat.
     */
    const sourceGalleryVariantId =
      String(
        sourceMainSlide.dataset.variantId || ''
      ).trim();

    if (!sourceGalleryVariantId) {
      console.warn(
        'Shared Gallery: Quell-Hauptbild hat keine data-variant-id.',
        sourceMainSlide
      );

      return false;
    }

    /*
     * Alle Bilder dieser bestehenden Galerie-Gruppe.
     *
     * Das Hauptbild selbst wird ausgeschlossen,
     * weil die neue Variante ihr eigenes Hauptbild bekommt.
     */
    const sharedMediaIds = slides
      .filter(slide => {
        return (
          String(
            slide.dataset.variantId || ''
          ).trim() === sourceGalleryVariantId
        );
      })
      .filter(slide => {
        return (
          getMediaId(slide) !== sourceMainId
        );
      })
      .sort((a, b) => {
        return (
          getMediaPosition(a) -
          getMediaPosition(b)
        );
      })
      .map(slide => getMediaId(slide))
      .filter(Boolean);

    /*
     * Eigenes Hauptbild der aktuell ausgewählten Variante.
     */
    const selectedMainId =
      selectedVariant.featuredMediaId
        ? String(
            selectedVariant.featuredMediaId
          )
        : null;

    const orderedMediaIds = [];

    if (selectedMainId) {
      orderedMediaIds.push(
        selectedMainId
      );
    }

    /*
     * Danach die gemeinsam verwendeten Folgebilder.
     */
    sharedMediaIds.forEach(mediaId => {
      const id = String(mediaId);

      if (
        !orderedMediaIds.includes(id)
      ) {
        orderedMediaIds.push(id);
      }
    });

    console.log(
      'Shared Gallery:',
      {
        selectedVariantId:
          String(variantId),
        selectedSet:
          selectedVariant.set,
        selectedColor:
          selectedVariant.color,
        selectedPackaging:
          selectedVariant.packaging,
        sourceColor:
          sourceColor,
        sourceGalleryVariantId:
          sourceGalleryVariantId,
        mainImage:
          selectedMainId,
        sharedImages:
          sharedMediaIds,
        allImages:
          orderedMediaIds
      }
    );

    /*
     * Falls aus irgendeinem Grund überhaupt kein Bild
     * gefunden wurde, nicht weiter eingreifen.
     */
    if (orderedMediaIds.length === 0) {
      return false;
    }

    const visibleMediaIds =
      new Set(
        orderedMediaIds.map(String)
      );

    /*
     * -------------------------
     * GROSSE PRODUKTGALERIE
     * -------------------------
     */

    slides.forEach(slide => {
      const id = getMediaId(slide);

      slide.classList.toggle(
        'hidden',
        !id ||
          !visibleMediaIds.has(
            String(id)
          )
      );
    });

    const carousel =
      section.querySelector(
        'media-carousel'
      );

    if (carousel) {
      const loader =
        carousel.querySelector(
          '[data-media-carousel-loading-overlay]'
        );

      /*
       * Sichtbare Slides physisch in die Reihenfolge:
       *
       * Hauptbild
       * → Folgebild 1
       * → Folgebild 2
       * → ...
       */
      orderedMediaIds.forEach(mediaId => {
        const slide = slides.find(
          item =>
            getMediaId(item) ===
            String(mediaId)
        );

        if (!slide) return;

        if (loader) {
          carousel.insertBefore(
            slide,
            loader
          );
        } else {
          carousel.appendChild(slide);
        }
      });

      /*
       * media-carousel speichert beim Laden seine Items.
       * Nach dem Umsortieren deshalb neu setzen.
       */
      carousel.items =
        orderedMediaIds
          .map(mediaId =>
            carousel.querySelector(
              `[data-media-id="${mediaId}"]`
            )
          )
          .filter(Boolean);

      carousel.currentIndex = 0;
      carousel.scrollLeft = 0;

      if (
        typeof carousel.updateItemOffsets ===
        'function'
      ) {
        carousel.updateItemOffsets();
      }

      if (
        typeof carousel.updateButtons ===
        'function'
      ) {
        carousel.updateButtons();
      }

      if (
        typeof carousel.updateShadow ===
        'function'
      ) {
        carousel.updateShadow();
      }

      if (
        typeof carousel.updateMaxHeight ===
        'function'
      ) {
        carousel.updateMaxHeight();
      }
    }

    /*
     * -------------------------
     * THUMBNAILS
     * -------------------------
     */

    const thumbnails =
      Array.from(
        section.querySelectorAll(
          '.product-thumbnail'
        )
      );

    thumbnails.forEach(thumbnail => {
      const id =
        String(
          thumbnail.dataset.mediaId || ''
        );

      thumbnail.classList.toggle(
        'hidden',
        !visibleMediaIds.has(id)
      );

      thumbnail.classList.remove(
        'active'
      );
    });

    /*
     * Auch die Thumbnail-Reihenfolge anpassen.
     */
    section
      .querySelectorAll(
        'product-thumbnails'
      )
      .forEach(group => {
        orderedMediaIds.forEach(
          mediaId => {
            const thumbnail =
              Array.from(
                group.querySelectorAll(
                  '.product-thumbnail'
                )
              ).find(
                item =>
                  String(
                    item.dataset.mediaId
                  ) ===
                  String(mediaId)
              );

            if (thumbnail) {
              group.appendChild(
                thumbnail
              );
            }
          }
        );

        /*
         * Hauptbild als aktiv markieren.
         */
        const firstThumbnail =
          Array.from(
            group.querySelectorAll(
              '.product-thumbnail'
            )
          ).find(
            item =>
              String(
                item.dataset.mediaId
              ) ===
              String(selectedMainId)
          );

        if (firstThumbnail) {
          firstThumbnail.classList.add(
            'active'
          );
        }
      });

    /*
     * Thumbnail-Scroller aktualisieren.
     */
    section
      .querySelectorAll(
        'scroll-carousel'
      )
      .forEach(scroller => {
        if (
          !scroller.querySelector(
            'product-thumbnails'
          )
        ) {
          return;
        }

        scroller.items =
          Array.from(
            scroller.querySelectorAll(
              '.product-thumbnail:not(.hidden)'
            )
          );

        scroller.scrollLeft = 0;

        if (
          typeof scroller.updateButtons ===
          'function'
        ) {
          scroller.updateButtons();
        }

        if (
          typeof scroller.updateShadow ===
          'function'
        ) {
          scroller.updateShadow();
        }
      });

    return true;
  }

  /*
   * =====================================================
   * ALTE GALERIE-LOGIK
   * =====================================================
   *
   * Wird für ALLE Produkte ohne den Tag
   * shared-color-gallery verwendet.
   *
   * Dadurch sollten andere Produkte unverändert bleiben.
   */
  function applyNormalGallery(
    section,
    variantId
  ) {
    const thumbnails =
      section.querySelectorAll(
        '.product-thumbnail'
      );

    const slides =
      section.querySelectorAll(
        '.product-gallery__slide'
      );

    thumbnails.forEach(
      thumbnail => {
        const id =
          thumbnail.getAttribute(
            'data-variant-id'
          );

        thumbnail.classList.toggle(
          'hidden',
          id !== String(variantId)
        );
      }
    );

    slides.forEach(slide => {
      const id =
        slide.getAttribute(
          'data-variant-id'
        );

      slide.classList.toggle(
        'hidden',
        id !== String(variantId)
      );
    });

    /*
     * Bestehender Fallback des Themes:
     * Wenn gar keine Galerie gefunden wurde,
     * alle Bilder wieder einblenden.
     */
    const visibleThumbs =
      section.querySelectorAll(
        '.product-thumbnail:not(.hidden)'
      );

    const visibleSlides =
      section.querySelectorAll(
        '.product-gallery__slide:not(.hidden)'
      );

    if (
      visibleThumbs.length === 0 ||
      visibleSlides.length === 0
    ) {
      thumbnails.forEach(
        thumbnail => {
          thumbnail.classList.remove(
            'hidden'
          );
        }
      );

      slides.forEach(slide => {
        slide.classList.remove(
          'hidden'
        );
      });
    }
  }

  /*
   * =====================================================
   * ERSTER SEITENAUFRUF
   * =====================================================
   */

  const initialSection =
    document.querySelector(
      '.section-main-product'
    );

  if (initialSection) {
    const configElement =
      initialSection.querySelector(
        '[data-shared-color-gallery-config]'
      );

    if (configElement) {
      try {
        const config =
          JSON.parse(
            configElement.textContent
          );

        applySharedGallery(
          initialSection,
          config.selectedVariantId
        );
      } catch (error) {
        console.error(
          'Shared Gallery beim Seitenstart fehlgeschlagen:',
          error
        );
      }
    } else {
      /*
       * Das entspricht dem ursprünglichen Verhalten
       * deines custom.js.
       */
      const visibleThumbs =
        initialSection.querySelectorAll(
          '.product-thumbnail:not(.hidden)'
        );

      const visibleSlides =
        initialSection.querySelectorAll(
          '.product-gallery__slide:not(.hidden)'
        );

      if (
        visibleThumbs.length === 0 ||
        visibleSlides.length === 0
      ) {
        initialSection
          .querySelectorAll(
            '.product-thumbnail'
          )
          .forEach(thumbnail => {
            thumbnail.classList.remove(
              'hidden'
            );
          });

        initialSection
          .querySelectorAll(
            '.product-gallery__slide'
          )
          .forEach(slide => {
            slide.classList.remove(
              'hidden'
            );
          });
      }
    }
  }

  /*
   * =====================================================
   * VARIANTENWECHSEL
   * =====================================================
   */

  document.addEventListener(
    'variant:change',
    event => {
      const variant =
        event.detail &&
        event.detail.variant;

      if (!variant) {
        return;
      }

      let section =
        event.target.closest(
          '.section-main-product'
        );

      if (!section) {
        section =
          document.querySelector(
            '.section-main-product'
          );
      }

      if (!section) {
        section =
          event.target.closest(
            '.product-grid'
          );
      }

      if (!section) {
        return;
      }

      /*
       * Nur dieses Tassenprodukt bekommt
       * die neue gemeinsame Galerie.
       */
      if (
        section.querySelector(
          '[data-shared-color-gallery-config]'
        )
      ) {
        applySharedGallery(
          section,
          variant.id
        );
      } else {
        /*
         * Alle anderen Produkte:
         * altes Verhalten.
         */
        applyNormalGallery(
          section,
          variant.id
        );
      }
    }
  );
});